import { z } from 'zod';
import { ScenarioName } from './block-rules.js';
import { IsoTime, ServerId } from './basics.js';
import { ServerGroupId } from './server.js';
/**
 * The scenarios the servers have raised alerts for (P11.16), for the Rules page's
 * trigger form: which exist, and — the point — which of them never led to a ban.
 * Read from the alerts' events, so it lists what has fired, not everything the hub
 * could install.
 */
export const CrowdsecScenarioQuery = z
    .object({
    server_id: ServerId.optional(),
    group_id: ServerGroupId.optional(),
    days: z.coerce.number().int().min(1).max(90).default(30),
})
    .strict()
    .refine((query) => query.server_id === undefined || query.group_id === undefined, {
    message: 'one of server_id and group_id, not both',
});
export const CrowdsecScenarioRow = z.object({
    /** Not always a hub name (a person's own scenario), so no more than text. */
    name: z.string().max(256),
    /** Whether a trigger rule may name it. */
    triggerable: z.boolean(),
    alerts: z.number().int().nonnegative(),
    /** Alerts that came with a decision: the scenario banned for itself. */
    banned: z.number().int().nonnegative(),
    addresses: z.number().int().nonnegative(),
    servers: z.number().int().nonnegative(),
    lastSeenAt: IsoTime,
});
export const CrowdsecScenarioResponse = z.object({
    from: IsoTime,
    to: IsoTime,
    scenarios: z.array(CrowdsecScenarioRow).max(200),
});
/** Whether a scenario name is one a trigger may hold. */
export const isTriggerable = (name) => ScenarioName.safeParse(name).success;
//# sourceMappingURL=crowdsec-scenarios.js.map